import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedAssessmentPeriodId } from '../../../common/selectors/auth';

import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { hexToRgb } from 'common/styles/colors';

const BarChart = ({ barChartData }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
  const selectedAssessmentPeriodId = useSelector(getSelectedAssessmentPeriodId);

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Team Pillar Scores',
        data: [],
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderColor: 'rgba(0, 0, 0, 1)',
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    if (!barChartData.length) return;
    const currentAPIndex = barChartData.findIndex(item => item.id === selectedAssessmentPeriodId);
    const currentData = barChartData[currentAPIndex]?.data || [];

    if (currentData.length) {
      const sortedData = [...barChartData[currentAPIndex].data].sort((a, b) =>
        a.option_name.localeCompare(b.option_name)
      );

      const names = sortedData.map(item => item.option_name);
      const overallScore = sortedData.map(item => parseFloat(item.overall_score.toFixed(1)));
      const colors = sortedData.map(item => item.color);
      const backgroundColors = colors.map(color => hexToRgb(color, 0.6));
      const borderColors = colors.map(color => hexToRgb(color, 0.8));

      const formattedData = {
        labels: names,
        datasets: [
          {
            label: 'Score',
            data: overallScore,
            backgroundColor: backgroundColors,
            borderColor: borderColors,
            borderWidth: 2,
          },
        ],
      };

      setChartData(formattedData);
    }
  }, [barChartData, selectedAssessmentPeriodId]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 10,
        ticks: {
          stepSize: 1,
        },
        title: {
          display: true,
          text: 'Overall Score',
          font: {
            family: 'Poppins',
            size: 11,
          },
        },
      },
    },
  };

  return (
    <div style={{ height: '470px', width: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default BarChart;
